import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { getCookie } from '../helpers/utils';

const API_URL = `/api/login/`;

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {

  constructor(private http: HttpClient) { }

  private getCsrfToken(): string {
    return getCookie('csrftoken');
  }

  login(user) {
    return this.http.post(
      API_URL,
      {
        username: user.username,
        password: user.password,
      },
      {
        headers: {
          'X-CSRFToken': this.getCsrfToken(),
        }
      }
    );
  }

  logOut() {
    return this.http.post(
      '/logout/',
      {},
      {responseType: 'text'}
    );
  }
}
